import React from "react";

import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import ArrowDownIcon from 'assets/icons/arrow-down.svg';

import classes from './FAQ.module.scss';

// `visibilityClassName` keeps the existing desktop-only behaviour by default;
// pages that want the FAQ on small screens too can pass an empty string.
const FAQ = ({ data, visibilityClassName = 'd-xl-block d-none' }) => {
    const accordionStyle = {
        '& p': {
            fontSize: '18px',
            fontWeight: 700
        },
        '&.Mui-expanded': {
            color: '#BB3A90'
        }
    };
    return (
        <>
            {data?.length > 0 && (
                <div className={`${classes['wrapper']} ${visibilityClassName}`}>

                    <h2>FAQs</h2>
                    {data?.map((item, idx) => (
                        <Accordion key={item.id ?? idx} className={classes['item']}>
                            <AccordionSummary
                                expandIcon={<ArrowDownIcon />}
                                sx={accordionStyle}
                            >
                                <Typography>{item.title}</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Typography component="div" dangerouslySetInnerHTML={{ __html: item.description }} />
                            </AccordionDetails>
                        </Accordion>
                    ))}
                </div>
            )}
        </>
    );
};

export default FAQ;